'use strict';

exports.__esModule = true;
exports.ImgBase = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _constants = require('../lib/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ImgBase = exports.ImgBase = function (_Component) {
  _inherits(ImgBase, _Component);

  function ImgBase(props, context) {
    _classCallCheck(this, ImgBase);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

    _initialiseProps.call(_this);

    var api = _this.getApi(context);
    _this.state = {
      isLoaded: api.isLoaded,
      imgSrc: null
    };
    return _this;
  }

  ImgBase.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    return this.state.imgSrc !== nextState.imgSrc || this.state.isLoaded !== nextState.isLoaded || this.isNextPropsDifferent(nextProps);
  };

  ImgBase.prototype.componentDidMount = function componentDidMount() {
    if (this.isRenderMode(_constants.RENDER_IMAGE_WITH_PLACEHOLDER) || this.isRenderMode(_constants.RENDER_IMAGE_WITH_PLACEHOLDER_INITIALLY) && !this.isLoaded()) {
      this.loadImage(this.props);
    }
  };

  ImgBase.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.isNextPropsDifferent(nextProps) && (this.isRenderMode(_constants.RENDER_IMAGE_WITH_PLACEHOLDER, nextProps) || this.isRenderMode(_constants.RENDER_IMAGE_WITH_PLACEHOLDER_INITIALLY, nextProps) && !this.isLoaded())) {
      this.loadImage(nextProps);
    }
  };

  ImgBase.prototype.render = function render() {
    var imgSrc = this.state.imgSrc;
    var _props = this.props,
        src = _props.src,
        render = _props.render;

    var result = void 0;

    if (src === null || src === undefined) {
      result = '';
    } else if (typeof src === 'string') {
      result = src;
    } else if (this.isRenderMode(_constants.RENDER_IMAGE)) {
      result = this.getImageSrc();
    } else if (this.isRenderMode(_constants.RENDER_PLACEHOLDER)) {
      result = this.getPlaceholderSrc();
    } else if (this.isRenderMode(_constants.RENDER_IMAGE_WITH_PLACEHOLDER)) {
      if (imgSrc) {
        result = imgSrc;
      } else {
        result = this.getPlaceholderSrc();
      }
    } else if (this.isRenderMode(_constants.RENDER_IMAGE_WITH_PLACEHOLDER_INITIALLY)) {
      if (this.isLoaded()) {
        result = this.getImageSrc();
      } else if (imgSrc) {
        result = imgSrc;
      } else {
        result = this.getPlaceholderSrc();
      }
    }

    return render({ src: result });
  };

  return ImgBase;
}(_react.Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.isNextPropsDifferent = function (nextProps) {
    var isSrcEqual = _this2.props.src === 'string' || _this2.props.src === null || _this2.props.src === undefined ? _this2.props.src === nextProps.src : _this2.props.src.file_name === (nextProps.src && nextProps.src.file_name);

    return _this2.props.renderMode !== nextProps.renderMode || _this2.props.fittingType !== nextProps.fittingType || _this2.props.width !== nextProps.width || _this2.props.height !== nextProps.height || _this2.props.height !== nextProps.height || _this2.props.children !== nextProps.children || _this2.props.isOnScreen !== nextProps.isOnScreen || !isSrcEqual;
  };

  this.getApi = function () {
    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this2.context;

    if (!_this2.imgProviderApi) {
      _this2.imgProviderApi = context.imgProviderApi();
    }
    return _this2.imgProviderApi;
  };

  this.isLoaded = function () {
    return _this2.state.isLoaded;
  };

  this.loadImage = function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this2.props;

    if (typeof props.src === 'string' || props.src === null || props.src === undefined) {
      return;
    }

    if (!props.isOnScreen) {
      return;
    }

    var imgSrc = _this2.getImageSrc(props);
    var img = new Image();
    img.src = imgSrc;
    if (img.complete) {
      _this2.setState({ imgSrc: imgSrc });
    } else {
      img.onload = function () {
        _this2.setState({ imgSrc: imgSrc });
      };
    }
  };

  this.getRenderMode = function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this2.props;
    return props.renderMode || _this2.getApi().renderMode;
  };

  this.isRenderMode = function (mode) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this2.props;

    return _this2.getRenderMode(props) === mode;
  };

  this.calculateSize = function (props) {
    var api = _this2.getApi();
    var resizeFn = props.fittingType === _constants.RESIZE_FIT ? api.calculateSizeFit : api.calculateSizeCover;
    var src = props.src,
        width = props.width,
        height = props.height;


    return resizeFn({
      oW: src.width,
      oH: src.height,
      w: width,
      h: height
    });
  };

  this.getPlaceholderSrc = function () {
    var size = _this2.calculateSize(_this2.props);
    var api = _this2.getApi();
    return api.buildPlaceholderSrc(_this2.props.src, size.width, size.height, Object.assign({ format: api.format }, _this2.props));
  };

  this.getImageSrc = function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this2.props;

    var size = _this2.calculateSize(props);
    var api = _this2.getApi();
    return api.buildImageSrc(props.src, size.width, size.height, Object.assign({ format: api.format }, props));
  };
};

ImgBase.interfacePropTypes = {
  src: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    file_name: _propTypes2.default.string, // eslint-disable-line camelcase
    width: _propTypes2.default.number,
    height: _propTypes2.default.number
  })]),
  width: _propTypes2.default.number,
  height: _propTypes2.default.number,
  fittingType: _propTypes2.default.oneOf([_constants.RESIZE_FIT, _constants.RESIZE_COVER]),
  renderMode: _propTypes2.default.oneOf([_constants.RENDER_IMAGE, _constants.RENDER_IMAGE_WITH_PLACEHOLDER, _constants.RENDER_PLACEHOLDER, _constants.RENDER_IMAGE_WITH_PLACEHOLDER_INITIALLY]),
  isOnScreen: _propTypes2.default.bool,
  encode: _propTypes2.default.bool
};

ImgBase.defaultProps = {
  isOnScreen: true
};

ImgBase.contextTypes = {
  imgProviderApi: _propTypes2.default.func
};

exports.default = ImgBase;